import Vue from 'vue'
import Router from 'vue-router'

import GeneralHome from '@/components/GeneralHome'
// 行业
import Industry from '@/components/industry/Index'
import IndustryDetail from '@/components/industry/Detail'
// 生产
import Product from '@/components/product/Index'
import ProductControl from '@/components/product/Control'
import ProductControlDetail from '@/components/product/ControlDetail'
import ProductFertility from '@/components/product/Fertility'
import ProductPlant from '@/components/product/Plant'
// 质量
import QualityIndex from '@/components/quality/Index'
// 流通
import SaleIndex from '@/components/sale/Index'
// 流通
import TraceIndex from '@/components/trace/Index'
// 流通
import Mp4Index from '@/components/mp4/Index'
// 病虫害
import DiseaseIndex from '@/components/disease'

// 超宽屏幕定制页起始页
import screen38496 from './screen38496'
import screen28896 from './screen28896'

import MapTools from './map-tools'

// 坐标转换工具（隐藏）
import CoordinateConvertor from '@/components/CoordinateConvertor'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      component: GeneralHome,
      redirect: '/industry',
      children: [{
          path: 'industry',
          component: Industry
        },
        {
          path: 'industry/:id',
          component: IndustryDetail
        },
        {
          path: 'product',
          component: Product,
          children: [{
              path: 'control/:town',
              component: ProductControl
            },
            {
              path: 'control/:town/:enterprise',
              component: ProductControlDetail
            },
            {
              path: 'fertility',
              component: ProductFertility
            },
            {
              path: 'plant',
              component: Mp4Index //ProductPlant
            }
          ]
        },
        {
          path: 'quality',
          component: QualityIndex
        },
        {
          path: 'sale',
          component: SaleIndex
        },
        {
          path: 'trace',
          component: TraceIndex
        },
        {
          path: 'mp4',
          component: Mp4Index
        },
        // 病虫害
        {
          path: 'disease',
          component: DiseaseIndex
        },
      ]
    },


    {
      path: '/coordinate-convertor',
      component: CoordinateConvertor
    },
    // 超宽屏专用
    screen38496,
    screen28896,
    // 地图工具
    MapTools
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js